import type { CarNotificationDefaultRecord } from '@navio/nsdk';

/**
 * Drivers (car managers) of the booked cars who have turned booking SMS off.
 *
 * The backend sends booking SMS to the car managers, so a manager with SMS off
 * means nobody on the car hears about the booking unless someone opts them in.
 */
export const getSilencedCarManagers = (carDefaults: CarNotificationDefaultRecord[]): CarNotificationDefaultRecord[] =>
  carDefaults.filter(({ isCarManager, smsBookingNotifications }) => isCarManager && !smsBookingNotifications);
